import Button from "../../../../../../components/bootstrap/Button";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../../../components/bootstrap/Modal";

const DeleteConfirmModal = ({ isOpen, title, row, loading, onClose, onConfirm }) => {
    return (
        <Modal
            id="modal-ifood-delete-confirm"
            isOpen={isOpen}
            setIsOpen={(value) => {
                if (!value) onClose();
            }}
            isStaticBackdrop
            isCentered
            size="sm"
        >
            <ModalHeader setIsOpen={onClose}>
                <ModalTitle id="modal-title-ifood-delete-confirm">{title}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                Tem certeza que deseja remover <strong>{row?.name || "este registro"}</strong> do iFood?
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" isLight onClick={onClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button color="danger" onClick={onConfirm} disabled={loading}>
                    {loading ? "Removendo..." : "Confirmar remoção"}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteConfirmModal;
